import PhotoOverlayItem from '../src/PhotoOverlayItem.tsx';
export default PhotoOverlayItem;
